import { ChangeDetectionStrategy, Component, inject, model, ModelSignal, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-error-dialog",
    templateUrl: "./error-dialog.component.html",
    styleUrl: "./error-dialog.component.scss",
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})
export class ErrorDialogComponent {
    readonly data = inject<any>(MAT_DIALOG_DATA);
    protected title: ModelSignal<string | null> = model<string | null>(this.data.title ?? "Error");
    protected error: ModelSignal<string> = model<string>(this.data.error ?? "Something went wrong");
    protected description: ModelSignal<string | null> = model<string | null>(this.data.description);
}
